import { gql } from '@apollo/client'

export const FIND_MCAT_STATISTICS_BY_GAME = gql`
  query findMCATStatisticsByGame($subjectId: String!, $endDate: DateTime, $startDate: DateTime) {
    findMcatStatisticsByGame(endDate: $endDate, startDate: $startDate, subjectId: $subjectId) {
      totalStatistics {
        avgAttemptsByUser
        totalAccumulatedXP
        totalCorrect
        totalGameOvers
        totalIncorrect
        totalPlays
        totalTimeSpent
        userCountWithMaxLevel
      }
      playSnippets {
        statsByMoreThanOneAttempt {
          mostCommonLevel
          userCount
        }
        statsByMoreThanFiveAttempts {
          mostCommonLevel
          userCount
        }
      }
    }
  }
`

export const GET_MCAT_SPECIFIC_GAME_ANALYTICS_ATTEMPTS = gql`
  query findMCATSpecificGameAnalyticsAttempts($subjectId: String!, $startDate: DateTime!, $endDate: DateTime!) {
    findMCATSpecificGameAnalyticsAttempts(subjectId: $subjectId, startDate: $startDate, endDate: $endDate) {
      date
      result {
        attempts
        correct
        incorrect
      }
    }
  }
`

export const GET_MCAT_SPECIFIC_GAME_ANALYTICS_LEVEL_PERFORMANCE = gql`
  query findMCATSpecificGameAnalyticsLevelPerformance($subjectId: String!, $startDate: DateTime, $endDate: DateTime) {
    findMCATSpecificGameAnalyticsLevelPerformance(subjectId: $subjectId, startDate: $startDate, endDate: $endDate) {
      level
      correctAnsweredCount
      incorrectAnsweredCount
    }
  }
`
